import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const ITEM_SCHEMA = [
  { key: "lead", label: "Lead word (optional)", type: "string" as const, placeholder: "Free delivery" },
  { key: "text", label: "Message Text", type: "string" as const },
  { key: "code", label: "Coupon Code (optional)", type: "string" as const },
  { key: "linkLabel", label: "Link text", type: "string" as const, placeholder: "Click here" },
  { key: "link", label: "Link (optional)", type: "string" as const, placeholder: "/shop" },
];

export const schema: ComponentSchema = {
  type: "announcement-bar",
  label: "Announcement Bar",
  description: "A black bar with a bold lead phrase, one line and links, or an accent band of words scrolling past.",
  supportedPages: [
    "home", "shop", "product", "category", "categories", "cart", "checkout",
    "contact", "wishlist",
  ],
  variants: [
    {
      id: "v1",
      label: "Black bar",
      fields: [
        { key: "items", label: "Announcement Items", type: "array", itemSchema: ITEM_SCHEMA },
        { key: "bgColor", label: "Background Color", type: "string", default: "#0989FF" },
        { key: "textColor", label: "Text Color", type: "string", default: "#ffffff" },
      ],
    },
    {
      id: "v2",
      label: "Scrolling band",
      fields: [
        {
          key: "items",
          label: "Words",
          type: "array",
          help: "Short words or phrases that scroll across an accent band, a star between each.",
          itemSchema: [{ key: "text", label: "Word or phrase", type: "string" as const }],
        },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
